import { render, staticRenderFns } from "./appltIndex.vue?vue&type=template&id=fd31563e&scoped=true"
import script from "./appltIndex.vue?vue&type=script&lang=js"
export * from "./appltIndex.vue?vue&type=script&lang=js"
import style0 from "./appltIndex.vue?vue&type=style&index=0&id=fd31563e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd31563e",
  null
  
)

export default component.exports